import React, { FormEvent, useEffect, useState } from "react";
import Axios from "API/Axios";
import { AxiosMethodEnum } from "API/Axios";
import { Axios_Route } from "API/AxiosRouts";
import { notify, ToastType } from "utils/Toast";
import { ValidationErrorMessages } from "utils/Error";
import { useDispatch } from "react-redux";
import {
  setUsernameAction,
  setTokenAction,
  setInitialStateAction,
  setIsLoginAction
} from "ReduxSaga/actions/UserActions";
import { phoneNumberCheck } from "../../utils/rejex";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";

interface Props {
  Component: any;
}

export interface LoginError {
  mobileError: string | null;
  otpError: string | null;
}

const Login: React.FC<Props> = ({ Component }) => {
  const [mobile, setMobile] = useState<string>("");
  const [otp, setOtp] = useState<string>("");
  const [allowToSubmit, setAllowToSubmit] = useState<boolean>(true);
  const [showErrors, setShowErrors] = useState<boolean>(false);
  const [error, setError] = useState<LoginError>({
    mobileError: null,
    otpError: null
  });
  const [loginStep, setLoginStep] = useState<1 | 2>(1);
  const cookies = new Cookies();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    cookies.remove("token");
    cookies.remove("refreshToken");
    dispatch(setInitialStateAction());
  }, []);

  useEffect(() => {
    if (showErrors) {
      errorHandling1();
    }
  }, [mobile]);

  useEffect(() => {
    if (showErrors) {
      errorHandling2();
    }
  }, [otp]);

  const errorHandling1 = () => {
    let AllowToContinue = true;

    if (mobile.length === 0) {
      error.mobileError = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.mobileError = null;
    }

    if (!phoneNumberCheck(mobile)) {
      error.mobileError =
        ValidationErrorMessages.ERRORS.MOBILE_VALIDATION_ERROR;
      AllowToContinue = false;
    } else {
      error.mobileError = null;
    }
    setError({ ...error });
    return AllowToContinue;
  };

  const errorHandling2 = () => {
    let AllowToContinue = true;

    if (otp.length === 0) {
      error.otpError = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.otpError = null;
    }
    setError({ ...error });

    return AllowToContinue;
  };

  const submitLogin = (e: FormEvent) => {
    e.preventDefault();

    setShowErrors(true);

    if (loginStep === 1) {
      let AllowToContinue = errorHandling1();
      if (AllowToContinue && allowToSubmit) {
        setAllowToSubmit(false);
        Axios(
          AxiosMethodEnum.post,
          `${Axios_Route.GET_OTP}?mobile=${mobile}`
        ).then(({ response, success }) => {
          setAllowToSubmit(true);
          if (success) {
            setLoginStep(2);
          } else if (!success) {
            notify(response.message, ToastType.error);
          }
          setShowErrors(false);
        });
      }
    } else {
      let AllowToContinue = errorHandling2();
      if (AllowToContinue && allowToSubmit) {
        setAllowToSubmit(false);
        Axios(
          AxiosMethodEnum.post,
          `${Axios_Route.VERIFY_OTP}?mobile=${mobile}&otp=${otp}`
        ).then(({ response, success }) => {
          setAllowToSubmit(true);
          if (success) {
            cookies.set("token", response.access_token);
            cookies.set("refreshToken", response.refresh_token);
            dispatch(setUsernameAction(mobile));
            dispatch(setTokenAction(response.access_token));
            dispatch(setIsLoginAction(true));
          } else if (!success) {
            notify(response.message, ToastType.error);
          }
          setShowErrors(false);
        });
      }
    }
  };

  return (
    <Component
      mobile={mobile}
      setMobile={setMobile}
      otp={otp}
      setOtp={setOtp}
      submitLogin={submitLogin}
      error={error}
      allowToSubmit={allowToSubmit}
      loginStep={loginStep}
    />
  );
};

export default Login;
